import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

export const deleteKitComponent = async (scope: RequestScope, id: number, options: WriteRequestOptions): Promise<EndpointResponse<void>> => {
  try {
    const response = await scopedApi(scope).delete<EndpointResponse<void>>(`/kit_component/${id}`, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
